import {inject, Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SecurityUtils} from 'src/app/services/auth/security.utils';
import {TenantAccount, TenantAccountActivity, TenantAccountRoleForm, TenantAccountWeeklyReportForm} from 'src/app/services/accounts/account.model';

@Injectable({providedIn: 'root'})
export class TenantAccountService {

  private httpClient = inject(HttpClient);

  private serviceUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/accounts`;

  getSelfTenantAccount(tenantId: string): Observable<TenantAccount|null> {
    return this.httpClient.get<TenantAccount|null>(`${this.serviceUrl(tenantId)}/_self`, {
      headers: SecurityUtils.getAuthHttpHeaders()
    });
  }


  /** Members seen in the audit log over the last 30 days, most recent first (KAB-2397). */
  getTenantAccountsActivity(tenantId: string): Observable<TenantAccountActivity[]> {
    return this.httpClient.get<TenantAccountActivity[]>(`${this.serviceUrl(tenantId)}/_activity`, {
      headers: SecurityUtils.getAuthHttpHeaders()
    });
  }

  getAllTenantAccountByTenantId(tenantId: string, filterPending?: boolean): Observable<TenantAccount[]> {
    return this.httpClient.get<TenantAccount[]>(`${this.serviceUrl(tenantId)}`, {
      headers: SecurityUtils.getAuthHttpHeaders(),
      params: filterPending !== undefined ? new HttpParams().set('filterPending', filterPending.toString()) : new HttpParams()
    });
  }

  updateTenantAccountRole(tenantId: string, accountId: string, form: TenantAccountRoleForm): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.serviceUrl(tenantId)}/${accountId}/role`, form, {
      headers: SecurityUtils.getAuthHttpHeaders()
    });
  }

  updateTenantAccountWeeklyReport(tenantId: string, accountId: string, form: TenantAccountWeeklyReportForm): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.serviceUrl(tenantId)}/${accountId}/weekly-report`, form, {
      headers: SecurityUtils.getAuthHttpHeaders()
    });
  }

  deleteTenantAccount(tenantId: string, accountId: string): Observable<boolean> {
    return this.httpClient.delete<boolean>(`${this.serviceUrl(tenantId)}/${accountId}`, {
      headers: SecurityUtils.getAuthHttpHeaders()
    });
  }

  sendInviteEmail(tenantId: string, accountId: string): Observable<boolean> {
	  return this.httpClient.post<boolean>(`${this.serviceUrl(tenantId)}/${accountId}/invite`, null, {
	  headers: SecurityUtils.getAuthHttpHeaders()
	});
  }
}
